import Icon from '../components/Icon.vue'

Icon.register({
  beer: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M368 96c44.1 0 80 35.9 80 80v128.9c0 31.5-18.6 60.2-47.4 73.1l-80.6 36v42.1c0 13.3-10.7 24-24 24h-272c-13.3 0-24-10.7-24-24v-400c0-13.3 10.7-24 24-24h272c13.3 0 24 10.7 24 24v40h48zM384 304.9v-128.9c0-8.8-7.2-16-16-16h-48v183.8l54.5-24.3c5.2-2.3 9.5-8.9 9.5-14.6zM208 384c8.8 0 16-7.2 16-16v-224c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16zM112 384c8.8 0 16-7.2 16-16v-224c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/beer.js
// module id = 655
// module chunks = 0